import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', senha: '' });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/auth/login', form);
            login(res.data.token, res.data.refreshToken); // Armazena o token no contexto e localStorage
            navigate('/dashboard');
        } catch (err) {
            console.error('Login Error:', err);
            alert(err.response?.data?.msg || 'Erro ao fazer login');
        }
    };

    return (
        <div
            className="w-screen h-screen flex justify-center items-center bg-cover bg-center"
            style={{
                backgroundImage: `url('/images/login_background.png')`,
            }}
        >
            {/* Formulário de Login */}
            <div className="w-[406px] p-6 bg-white rounded-lg border border-slate-300 flex flex-col justify-center items-center gap-6">
                {/* Logo */}
                <div className="w-full flex justify-center mb-4">
                    <img
                        src="/images/logo.png"
                        alt="Logo"
                        className="max-w-full h-auto"
                    />
                </div>

                {/* Formulário */}
                <form onSubmit={handleSubmit} className="w-full">
                    {/* Campo de E-mail */}
                    <div className="flex flex-col gap-1 mb-4">
                        <label
                            htmlFor="email"
                            className="text-slate-700 text-sm font-medium"
                        >
                            E-mail
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* Campo de Senha */}
                    <div className="flex flex-col gap-1 mb-4">
                        <label
                            htmlFor="senha"
                            className="text-slate-700 text-sm font-medium"
                        >
                            Senha
                        </label>
                        <input
                            id="senha"
                            name="senha"
                            type="password"
                            value={form.senha}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* Link Esqueceu a Senha */}
                    <div className="flex justify-end mb-4">
                        <a
                            href="/forgot-password"
                            className="text-stone-600 text-base font-extralight font-['Inter'] leading-normal"
                        >
                            Esqueceu a Senha?
                        </a>
                    </div>

                    {/* Botão de Login */}
                    <button
                        type="submit"
                        className="w-full px-4 py-2 bg-stone-600 text-white rounded-md hover:bg-stone-700 transition duration-200"
                    >
                        Entrar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
